import TelegramIcon from '@/Icons/socials/TelegramIcon/TelegramIcon';
import XIcon from '@/Icons/socials/XIcon/XIcon';

export const socialLinks = [
	{ title: 'X', href: 'https://x.com/otherworldxyz', icon: <XIcon /> },
	{
		title: 'Telegram',
		href: 'https://t.me/otherworldxyz',
		icon: <TelegramIcon />,
	},
];
